import React from "react";
import { DisabledPrompt } from "bcms-react";
import { TableBody, TableColumnContainer, TableColumnView, TableView, WidgetContainer, WidgetView } from "components/shared";
import { PrimaryButton, UICheckbox } from "components/ui";
import NoWireTransferTableRow from "components/pages/WiresActivityPage/components/NoWireTransferTableRow";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function ProcessedWireTemplatesWidget
 * @return {React.Component}
 * @exported true
 * @description The Widget that shows the processed wire transfers
 */
export default function ProcessedWireTemplatesWidget({ children }) {
    return (
        <WidgetContainer className="processed-wire-templates-widget">
            <WidgetView text="Processed Wire Transfers">
                <DisabledPrompt>
                    <UICheckbox label="Show Search Options" value="" />
                </DisabledPrompt>

                {/* Desktop Processed Wire Templates table view */}
                <ProcessedWireTemplatesTable />

                <DisabledPrompt>
                    <PrimaryButton text="Export" />
                </DisabledPrompt>

            </WidgetView>
        </WidgetContainer>
    )
}


/**
 * @function ProcessedWireTemplatesWidget
 * @return {React.Component}
 * @exported true
 * @description This is the table showing processed wire transfers on the Wire Activity page.
 */
function ProcessedWireTemplatesTable(props) {
    return (
        <TableView className="processed-wire-templates-table">
            <TableColumnContainer>
                <TableColumnView className="text-left ref-number-text" text="Ref #" />
                <TableColumnView className="text-left payee-text" text="Payee" />
                <TableColumnView className="text-left funding-account-text" text="Funding Account" />
                <TableColumnView className="text-left amount-text" text="Amount" />
                <TableColumnView className="text-left status-text" text="Status" />
                <TableColumnView className="text-left wire-date-text" text=
                    {<>Wire Date
                        <DisabledPrompt>
                            <SVGAsset id="ArrowDownIcon" className="clickable" />
                        </DisabledPrompt>
                    </>}
                />
                <TableColumnView className="text-left fed-details-text" text="Fed Details" />
            </TableColumnContainer>
            <TableBody>
                <NoWireTransferTableRow colspan="7" />
            </TableBody>
        </TableView>
    )
}